import { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withStyles } from "@mui/styles";
import Accordion from '@mui/material/Accordion';
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import IconButton from "@mui/material/IconButton";
import { getCurrentFunctionName } from "../../performanceModeManager";
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import './FormSection.css'
import { Document, Page, pdfjs } from 'react-pdf'
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;


const styles = (theme) => ({
	heading: {
		fontSize: theme.typography.pxToRem(15),
		flexBasis: "33.33%",
		flexShrink: 0,
	},
	AccordionSummaryContent: {
		content: {
			margin: 3,
		},
	},
});

class FormDocumentSection extends Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: this.props.expandedSectionId === this.props.document.internalId,
			numPages: null,
		};
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		let expanded = nextProps.expandedSectionId === nextProps.internalId;

		if (prevState.expanded === expanded) return prevState;

		return {
			expanded,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		if ((nextProps.expandedSectionId === nextProps.internalId) !== this.state.expanded)
			return true;

		if (this.props.internalId !== nextProps.internalId) return true;

		if (!nextState.expanded) return false;

        return false
	}

	onSectionHeaderClick = () => {
		this.props.onClick(this.props.internalId);
	};

	getSectionClasses() {
		let classes = "";

		if (this.props.expandedSectionId === this.props.internalId)
			classes = classes.concat("expanded-section");

		return classes;
	}

	getClasses() {
		let classes = "section-header without-side-padding";

		if (this.props.expandedSectionId === this.props.internalId)
			classes = classes.concat(" expanded-section");

		return classes;
	}

	onDocumentLoadSuccess({ numPages }) {
		this.setState({ numPages });
	}

	render() {
		console.perfLog(getCurrentFunctionName());

		const { classes } = this.props;
		let documentElement = null;

		if (this.props.expandedSectionId) {
            documentElement = (
				<div>
					<Box display="flex" justifyContent="center" mt={2} mb={2}>
						<Button
							variant="contained"
							color="primary"
							onClick={() => {
							const file = this.props.document.file;
							const url = URL.createObjectURL(file);
							const link = document.createElement('a');
							link.href = url;
							link.download = this.props.document.name + ".pdf";
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
							URL.revokeObjectURL(url);
							}}
						>
							Télécharger le PDF
						</Button>
					</Box>
					<div
						className="pdf-document-container"
						ref={(el) => (this.pdfContainer = el)}
						tabIndex={0}
						style={{ width: '100%', overflow: 'auto', position: 'relative' }}
						aria-label={`Document ${this.props.document.name}`}
					>
						<Document
							file={this.props.document.file}
							renderMode="svg"
							onLoadSuccess={this.onDocumentLoadSuccess.bind(this)}
						>
							{Array.from(
								new Array(this.state.numPages),
								(el, index) => (
									<Page
										key={`page_${index + 1}`}
										pageNumber={index + 1}
									/>
								),
							)}
						</Document>
					</div>
				</div>                
            );
        }

		let expandedElement = null;

		if (this.props.expandedSectionId !== this.props.internalId)
			expandedElement = (
				<IconButton
					color="inherit"
					onClick={this.onSectionHeaderClick.bind(this)}
					aria-label="Étendre"
				>
					<ExpandMoreIcon />
				</IconButton>
			);
		else
			expandedElement = (
				<IconButton
					color="inherit"
					onClick={this.onSectionHeaderClick.bind(this)}
					aria-label="Réduire"
				>
					<ExpandLessIcon />
				</IconButton>
			);

		return (
			<div
				className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
				ref={(panel) => (this.panel = panel)}
			>
				<Accordion
					expanded={this.state.expanded}
					className={this.getSectionClasses()}
				>
					<AccordionSummary
						className={this.getClasses()}
						classes={{ content: classes.AccordionSummaryContent.content }}
					>
						<div className="col-lg-10 col-md-10 col-sm-10 col-10 row without-side-padding without-margin">
							<div className="without-side-padding col-lg-2 col-md-2 col-sm-2 col-2">
								{expandedElement}
							</div>
							<div
								className="col-lg-10 col-md-10 col-sm-10 col-10 without-side-padding"
								onClick={this.onSectionHeaderClick.bind(this)}
							>
								<Typography className={classes.heading}>
									{this.props.document.name}
								</Typography>
							</div>
						</div>
					</AccordionSummary>
					<AccordionDetails className="form-panel-details">
						<div className="form-section">
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 row form-section">
								{documentElement}
							</div>
						</div>						
					</AccordionDetails>
				</Accordion>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		form: state.form.currentForm,
		activeUser: state.activeUser,
		expandedSectionId: state.form.currentSectionId,
		currentInterview: state.form.currentInterview,
	};
};

const mapDispatchToProps = () => {
	return {
	};
};

export default compose(withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(FormDocumentSection);
